import React from 'react';
import { Code, Briefcase } from 'lucide-react';
export function Hero() {
  return <section className="bg-gray-50 py-12 md:py-20 lg:py-28" data-id="element-159">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-160">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-161">
          <div className="md:w-1/2 md:pr-12 text-center md:text-left" data-id="element-162">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 md:mb-5 leading-tight" data-id="element-163">
              Hire Laravel Developers with Confidence.
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-6 md:mb-8" data-id="element-164">
              Powered by{' '}
              <a href="https://certificationforlaravel.com" className="text-primary hover:underline font-medium" data-id="element-165">
                Certification for Laravel
              </a>{' '}
              — the community-driven program that sets the standard for Laravel
              expertise. Our recruitment tests give you a reliable, objective
              way to evaluate real-world skills.
            </p>
            <div className="bg-white px-4 sm:px-5 py-3 sm:py-4 rounded-xl border border-gray-200 mb-8 md:mb-10 inline-flex items-center max-w-full" data-id="element-166">
              <Briefcase size={20} className="text-primary mr-2 sm:mr-3 flex-shrink-0" data-id="element-167" />
              <span className="font-medium text-sm sm:text-base" data-id="element-168">
                <span className="text-primary" data-id="element-169">+1,465</span> job openings for
                Laravel developers across various job platforms.
              </span>
            </div>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 justify-center md:justify-start" data-id="element-170">
              <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="px-6 py-3 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors text-center font-medium" data-id="element-171">
                Try a Sample Test
              </a>
              <a href="#pricing" className="px-6 py-3 border border-primary text-primary rounded-2xl hover:bg-primary/5 transition-colors text-center font-medium" data-id="element-172">
                Buy Recruitment Tests
              </a>
            </div>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0 w-full" data-id="element-173">
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 border border-gray-200" data-id="element-174">
              <div className="flex items-center mb-3 sm:mb-4" data-id="element-175">
                <div className="flex space-x-2" data-id="element-176">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-500" data-id="element-177"></div>
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-yellow-500" data-id="element-178"></div>
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-500" data-id="element-179"></div>
                </div>
                <div className="ml-3 sm:ml-4 text-xs sm:text-sm text-gray-500" data-id="element-180">
                  Laravel Recruitment Test
                </div>
              </div>
              <div className="font-mono text-xs sm:text-sm bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200 overflow-x-auto" data-id="element-181">
                <pre className="text-gray-800" data-id="element-182">
                  <code data-id="element-183">{`// Sample Laravel Test
Route::middleware('auth')->group(function () {
    Route::get('/dashboard', function () {
        return view('dashboard');
    })->name('dashboard');
    Route::resource('posts', PostController::class);
});`}</code>
                </pre>
              </div>
              <div className="mt-3 sm:mt-4 flex items-center text-xs sm:text-sm text-gray-500" data-id="element-184">
                <Code size={16} className="mr-2" data-id="element-185" />
                <span data-id="element-186">Evaluate real-world Laravel skills</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}